var sweetAlert = {
  methods: {
    alertPop (icon, text) {
      this.$swal.fire({
        icon: icon || 'warning',
        title: '提示訊息',
        html: `<p class="text-center">${text}</p>`,
        confirmButtonText: `確定`,
        showCloseButton: true,
        showConfirmButton: true,
        focusConfirm: false,
        showDenyButton: false,
        customClass: {
          container: '',
          popup: 'p-4',
          header: 'p-0',
          closeButton: '',
          title: 'text-base text-blue-600 underline font-base',
          htmlContainer: 'p-0 font-semibold leading-loose',
          actions: 'm-2',
          confirmButton: 'bgLiveABCRed',
          denyButton: 'denyButton-gept'
        }
      })
    }
  }
}

export default sweetAlert
